<ng-container>
	<app-header></app-header>
	<ng-content></ng-content>
	<app-footer></app-footer>
</ng-container>
